import { IconButton, Menu } from '@mui/material';
import { getSelectorAttribute, usagePageSelectors } from '@vy/app-selectors';
import { VyIcon } from '@vy/ui-design-system';
import { useMenu } from '../../../../hooks/use-menu';
import { DeleteMeasurementsDialog } from './DeleteMeasurementsDialog';
import { FileFeedMenuItem } from './MeasurementsUpload/FileFeedMenuItem.tsx';

type DataMeteringMenuProps = {
  deleteVisible: boolean;
  selectedMeasurementIds: string[];
};

export const DataMeteringMenu: React.FC<DataMeteringMenuProps> = ({
  selectedMeasurementIds,
  deleteVisible,
}) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        {...getSelectorAttribute(usagePageSelectors.header.dotMenu.dotMenuButton)}
      >
        <VyIcon icon="DotsMenu" />
      </IconButton>

      <Menu
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            className: 'max-w-[200px] w-full rounded-lg',
          },
        }}
      >
        <FileFeedMenuItem />
        {deleteVisible && <DeleteMeasurementsDialog measurementIds={selectedMeasurementIds} />}
      </Menu>
    </>
  );
};
